import {isNumeric} from 'rxjs/internal-compatibility';
import {GdkReqDataSql} from '../types';

// @dynamics
export class GdkUtils {
  public static filterArrayByString(mainArr, searchText): any {
    if (searchText === '') {
      return mainArr;
    }

    searchText = searchText.toLowerCase();

    return mainArr.filter(itemObj => {
      return this.searchInObj(itemObj, searchText);
    });
  }

/*

 */
  public static searchInObj(itemObj, searchText): boolean {
    for (const prop in itemObj) {
      if (!itemObj.hasOwnProperty(prop)) {
        continue;
      }

      const value = itemObj[prop];

      if (typeof value === 'string') {
        if (this.searchInString(value, searchText)) {
          return true;
        }
      } else if (Array.isArray(value)) {
        if (this.searchInArray(value, searchText)) {
          return true;
        }
      }

      if (typeof value === 'object') {
        if (this.searchInObj(value, searchText)) {
          return true;
        }
      }
    }
  }

  public static searchInArray(arr, searchText): boolean {
    for (const value of arr) {
      if (typeof value === 'string') {
        if (this.searchInString(value, searchText)) {
          return true;
        }
      }

      if (typeof value === 'object') {
        if (this.searchInObj(value, searchText)) {
          return true;
        }
      }
    }
  }


  public static searchInString(value, searchText): any {
    return value.toLowerCase().includes(searchText);
  }


  public static generateGUID(): string {
    function S4(): string {
      return Math.floor((1 + Math.random()) * 0x10000)
        .toString(16)
        .substring(1);
    }

    return S4() + S4();
  }

  public static generateGUID_TIME(): string {
    return new Date().getTime().toString(16);
  }

  public static generateDateID(): string {
    const ngay_thang = new Date();
    let id_ngay = ngay_thang.getFullYear().toString().substr(2) + ((ngay_thang.getMonth() + 1) < 10 ? '0' + (ngay_thang.getMonth() + 1) : (ngay_thang.getMonth() + 1).toString()) +
      (ngay_thang.getDate() < 10 ? '0' + ngay_thang.getDate() : ngay_thang.getDate().toString());

    id_ngay = id_ngay + '-' + Math.floor((1 + Math.random()) * 0x1000).toString().substring(1);
    return id_ngay;
  }

  public static toggleInArray(item, array): void {
    if (array.indexOf(item) === -1) {
      array.push(item);
    } else {
      array.splice(array.indexOf(item), 1);
    }
  }


  public static handleize(text): string {
    return text.toString().toLowerCase()
      .replace(/\s+/g, '-')           // Replace spaces with -
      .replace(/[^\w\-]+/g, '')       // Remove all non-word chars
      .replace(/\-\-+/g, '-')         // Replace multiple - with single -
      .replace(/^-+/, '')             // Trim - from start of text
      .replace(/-+$/, '');            // Trim - from end of text
  }

  public static dateToString(v: Date): string {
    const ngay = v.getDate();
    const thang = v.getMonth() + 1;
    const nam = v.getFullYear();
    const gio = v.getHours();
    const phut = v.getMinutes();
    const giay = v.getSeconds();
    const keq = `${nam}-${thang < 10 ? '0' + thang : thang}-${ngay < 10 ? '0' + ngay : ngay} ${gio}:${phut}:${giay}`;
    return keq;
  }


  public static queryToJson(obj: any): any {
    if (Array.isArray(obj)) {
      return obj.map(item => {

        for (const ind in item) {
          const val = item[ind];
          if (typeof val == 'string') {
            if (['[', '{'].includes((val + '')[0]) && [']', '}'].includes(val[(val + '').length - 1])) {
              item[ind] = JSON.parse(val);
            } else {
              if (isNumeric(val[0] + '') && (val).split('T')[0].split('-').length == 3) {
                //  console.log(val);
                item[ind] = new Date(val);
              }


            }
          }
        }
        return item;
      });
    }
    return obj;

  }


  public static parms_gdkReqDataSql(obj?: any[]): any[] {
    if (obj) {
      for (const i in Object.keys(obj)) {
        if (typeof obj[i] === 'object') {
          //  console.log(i, obj[i]);
          if (obj[i] instanceof Date) {
            obj[i] = this.dateTimeToStringYMDHM(obj[i]);
          } else {
            obj[i] = JSON.stringify(obj[i]);
          }
        }
      }
      return obj;
    } else {
      return [];
    }

  }

  public static parms_ReqDataSql(data: GdkReqDataSql): GdkReqDataSql {
    if (data.reqData) {
      data.reqData.parms = this.parms_gdkReqDataSql(data.reqData.parms);
      if (data.obif) {
        if (data.nextif) {
          data.nextif = this.parms_ReqDataSql(data.nextif);
        }
        if (data.next) {
          data.next = this.parms_ReqDataSql(data.next);
        }

      }
    }
    return data;
  }

  public static parms_andObject_Date_toString(obj?: any): any {
    if (obj) {
      for (const i in Object.keys(obj)) {
        if (typeof obj[i] === 'object') {
          //  console.log(i, obj[i]);
          if (obj[i] instanceof Date) {
            //  console.log('parms_andObject_Date_toString', obj[i]);
            try {
              obj[i] = obj[i].toJSON();
            } catch {
              obj[i] = JSON.stringify(obj[i]).replace(/"/g, '');
            }

            console.log('parms_andObject_Date_toString', obj[i]);
          }
        }
      }
      return obj;
    }
    return [];
  }

  public static parms_Convert_mongodb(data: GdkReqDataSql, lang: string = 'vi'): GdkReqDataSql {
    if (data.reqData) {
      if (!data.reqData.parmsOb) {
        data.reqData.parmsOb = {};
        data.reqData.parmsOb['lang'] = lang;
      } else if (!data.reqData.parmsOb['lang']) {
        data.reqData.parmsOb['lang'] = lang;
      }
      data.reqData.parms = this.parms_andObject_Date_toString(data.reqData.parms);
      if (data.obif) {
        if (data.nextif) {
          data.nextif = this.parms_Convert_mongodb(data.nextif, lang);
        }
        if (data.next) {
          data.next = this.parms_Convert_mongodb(data.next, lang);
        }

      }
    }
    return data;
  }

  public static dateTimeEqual(d1: Date, d2: Date): boolean {
    if (this.dateTimeToStringYMDHM(d1) == this.dateTimeToStringYMDHM(d2)) {
      return true;
    }
    return false;
  }

  public static dateEqual(d1: Date, d2: Date): boolean {
    if (this.dateToStringYMD(d1) == this.dateToStringYMD(d2)) {
      return true;
    }
    return false;
  }

  public static dateToStringYMD(d: Date): string {
    return [d.getFullYear(), d.getMonth() + 1, d.getDate()].join('-');
  }

  public static dateTimeToStringYMDHM(d: Date): string {
    return [d.getFullYear(), d.getMonth() + 1, d.getDate()].join('-') + ' ' + [d.getHours(), d.getMinutes() + 1].join(':');
  }

  public static date2Form(d: Date): string {
    return [d.getDate(), d.getMonth() + 1, d.getFullYear()].join('/');
  }

  public static dateTime2Form(d: Date): string {
    return [d.getDate(), d.getMonth() + 1, d.getFullYear()].join('/') + ' ' + [d.getHours(), d.getMinutes() + 1].join(':');
  }

  public static dateForm2DB(d: string): string {
    const dts = d.split(' ')[0].split('/');
    return [dts[2], dts[1], dts[0]].join('-');
  }

  public static dateTimeForm2DB(d: string): string {
    const ds = d.split(' ')[0].split('/');
    let tt = d.split(' ')[1];
    if (!tt) {
      tt = '0:0';
    }
    return [ds[2], ds[1], ds[0]].join('-') + ' ' + tt;
  }

  public static clone(obj: any): any {
    return JSON.parse(JSON.stringify(obj));
  }

  public static saochep(obj: any): any {
    return JSON.parse(JSON.stringify({vidu: obj}))['vidu'];

  }


  public static createUrlFromText(html: string): string {
    const bold = new Blob([html], {type: 'text/html; charset=utf-8'});
    return URL.createObjectURL(bold);
  }

  public static createUrlFromTextAndPrinter(html: string, title: string = 'TiÃªu Äá»'): string {
    const bold = new Blob([`<html><head><title>${title}</title></head><body onload='this.focus(); this.print();' style="width: 100%">
${html}
</body>
</html>`], {type: 'text/html; charset=utf-8'});
    return URL.createObjectURL(bold);
  }

  public static TrfMenu(sources: any[], id: string, keyParent: string, valueParent: string, nameRoot: string = 'root') {
// Sao chÃ©p cÃ¡c máº£ng lá»c
    const mm = JSON.parse(JSON.stringify(sources.filter(f => f[keyParent] === valueParent)));
// kiá»m tra máº£ng cÃ³ rá»ng hay khÃ´ng
    if (mm.length > 0) {
// Táº¡o má»t chuá»i rá»ng Äá» cáº­p nháº­t vÃ o máº£ng cÃ¹ng cáº¥p
      let chuoi = [];
// Äá»c tá»«ng giÃ¡ trá» cá»§a máº£ng
      mm.forEach(e => {
        // ThÃªm vÃ o máº£ng vÃ¬ nÃ³ lÃ  cung cáº¥p, Táº¡o ra cáº¥p con tÆ°Æ¡ng á»©ng cá»§a nÃ³
        const children = this.TrfMenu(sources, id, keyParent, e[id], nameRoot);
        const kieu = (valueParent === nameRoot ? 'group' : (children.length > 0 ? 'collapsable' : 'item'));
        if (!e['type']) {
          e['type'] = kieu;
        }
        if (children.length > 0) {
          chuoi = [...chuoi, ...[Object.assign(e, {children: children})]];
        } else {
          chuoi = [...chuoi, ...[e]];
        }
      });
// Tráº£ vá» káº¿t quáº£
      return chuoi;
    } else {
// Káº¿t thÃºc láº·p
      return [];
    }
  }

  public static TreeMenu(sources: any[], idName: string, parentName: string, valueParent: string, child_name: string = 'childrent') {
// Sao chÃ©p cÃ¡c máº£ng lá»c
    const mm = JSON.parse(JSON.stringify(sources.filter(f => f[parentName] === valueParent)));
// kiá»m tra máº£ng cÃ³ rá»ng hay khÃ´ng
    if (mm.length > 0) {
// Táº¡o má»t chuá»i rá»ng Äá» cáº­p nháº­t vÃ o máº£ng cÃ¹ng cáº¥p
      let chuoi = [];
// Äá»c tá»«ng giÃ¡ trá» cá»§a máº£ng
      mm.forEach(e => {
        // ThÃªm vÃ o máº£ng vÃ¬ nÃ³ lÃ  cung cáº¥p, Táº¡o ra cáº¥p con tÆ°Æ¡ng á»©ng cá»§a nÃ³
        const children = {};
        children[child_name] = this.TrfMenu(sources, idName, parentName, e[idName]);

        chuoi = [...chuoi, ...[Object.assign(e, children)]];
      });
// Tráº£ vá» káº¿t quáº£
      return chuoi;
    } else {
// Káº¿t thÃºc láº·p
      return [];
    }
  }

  public static mergeObject(obj1: any[], obj2: any[], fieldId: string = 'id', fieldChildren: string = 'children'): any[] {
    fieldId = fieldId || (fieldId = 'id');
    fieldChildren = fieldChildren || (fieldChildren = 'children');
    const obj: any[] = [];
    const ids = {};
    for (const item of obj1) {
      ids[item[fieldId]] = item;
      obj.push(item);
    }
    for (const item of obj2) {
      if (ids[item[fieldId]] != undefined) {
        for (const i of Object.keys(item)) {
          if (i != 'children') {
            ids[item[fieldId]][i] = item[i];
          }
        }
        if (ids[item[fieldId]][fieldChildren] && item[fieldChildren]) {
          ids[item[fieldId]][fieldChildren] = this.mergeObject(ids[item[fieldId]][fieldChildren], item[fieldChildren], fieldId, fieldChildren);
        }
      } else {
        obj.push(item);
      }
    }
    return obj;
  }

  public static phan_cap_mang(sources: any[], id: string, nameP: string, valueP: string, optionsAddField: { name: string, value: string } = {
    name: 'dau',
    value: '-'
  }): any[] {
    const mm = JSON.parse(JSON.stringify(sources.filter(f => f[nameP] === valueP)));
    if (mm.length > 0) {
      let chuoi = [];
      mm.forEach(e => {
        const tt = JSON.parse(JSON.stringify(optionsAddField));
        tt.value = tt.value + tt.value;
        const children = this.phan_cap_mang(sources, id, nameP, e[id], tt);
        e[tt.name] = optionsAddField.value;
        chuoi = [...chuoi, ...[e], ...children];
      });
      return chuoi;
    } else {
      return [];
    }
  }

  public static mat_icon_all(): any[] {
    return [
      {id: '3d_rotation', ten: '3d rotation'},
      {id: 'ac_unit', ten: 'ac unit'},
      {id: 'access_alarm', ten: 'access alarm'},
      {id: 'access_alarms', ten: 'access alarms'},
      {id: 'access_time', ten: 'access time'},
      {id: 'accessibility', ten: 'accessibility'},
      {id: 'accessible', ten: 'accessible'},
      {id: 'account_balance', ten: 'account balance'},
      {id: 'account_balance_wallet', ten: 'account balance wallet'},
      {id: 'account_box', ten: 'account box'},
      {id: 'account_circle', ten: 'account circle'},
      {id: 'adb', ten: 'adb'},
      {id: 'add', ten: 'add'},
      {id: 'add_a_photo', ten: 'add a photo'},
      {id: 'add_alarm', ten: 'add alarm'},
      {id: 'add_alert', ten: 'add alert'},
      {id: 'add_box', ten: 'add box'},
      {id: 'add_circle', ten: 'add circle'},
      {id: 'add_circle_outline', ten: 'add circle outline'},
      {id: 'add_location', ten: 'add location'},
      {id: 'add_shopping_cart', ten: 'add shopping cart'},
      {id: 'add_to_photos', ten: 'add to photos'},
      {id: 'add_to_queue', ten: 'add to queue'},
      {id: 'adjust', ten: 'adjust'},
      {id: 'airline_seat_flat', ten: 'airline seat flat'},
      {id: 'airline_seat_flat_angled', ten: 'airline seat flat angled'},
      {id: 'airline_seat_individual_suite', ten: 'airline seat individual suite'},
      {id: 'airline_seat_legroom_extra', ten: 'airline seat legroom extra'},
      {id: 'airline_seat_legroom_normal', ten: 'airline seat legroom normal'},
      {id: 'airline_seat_legroom_reduced', ten: 'airline seat legroom reduced'},
      {id: 'airline_seat_recline_extra', ten: 'airline seat recline extra'},
      {id: 'airline_seat_recline_normal', ten: 'airline seat recline normal'},
      {id: 'airplanemode_active', ten: 'airplanemode active'},
      {id: 'airplanemode_inactive', ten: 'airplanemode inactive'},
      {id: 'airplay', ten: 'airplay'},
      {id: 'airport_shuttle', ten: 'airport shuttle'},
      {id: 'alarm', ten: 'alarm'},
      {id: 'alarm_add', ten: 'alarm add'},
      {id: 'alarm_off', ten: 'alarm off'},
      {id: 'alarm_on', ten: 'alarm on'},
      {id: 'album', ten: 'album'},
      {id: 'all_inclusive', ten: 'all inclusive'},
      {id: 'all_out', ten: 'all out'},
      {id: 'android', ten: 'android'},
      {id: 'announcement', ten: 'announcement'},
      {id: 'apps', ten: 'apps'},
      {id: 'archive', ten: 'archive'},
      {id: 'arrow_back', ten: 'arrow back'},
      {id: 'arrow_downward', ten: 'arrow downward'},
      {id: 'arrow_drop_down', ten: 'arrow drop down'},
      {id: 'arrow_drop_down_circle', ten: 'arrow drop down circle'},
      {id: 'arrow_drop_up', ten: 'arrow drop up'},
      {id: 'arrow_forward', ten: 'arrow forward'},
      {id: 'arrow_upward', ten: 'arrow upward'},
      {id: 'art_track', ten: 'art track'},
      {id: 'aspect_ratio', ten: 'aspect ratio'},
      {id: 'assessment', ten: 'assessment'},
      {id: 'assignment', ten: 'assignment'},
      {id: 'assignment_ind', ten: 'assignment ind'},
      {id: 'assignment_late', ten: 'assignment late'},
      {id: 'assignment_return', ten: 'assignment return'},
      {id: 'assignment_returned', ten: 'assignment returned'},
      {id: 'assignment_turned_in', ten: 'assignment turned in'},
      {id: 'assistant', ten: 'assistant'},
      {id: 'assistant_photo', ten: 'assistant photo'},
      {id: 'attach_file', ten: 'attach file'},
      {id: 'attach_money', ten: 'attach money'},
      {id: 'attachment', ten: 'attachment'},
      {id: 'audiotrack', ten: 'audiotrack'},
      {id: 'autorenew', ten: 'autorenew'},
      {id: 'av_timer', ten: 'av timer'},
      {id: 'backspace', ten: 'backspace'},
      {id: 'backup', ten: 'backup'},
      {id: 'battery_alert', ten: 'battery alert'},
      {id: 'battery_charging_full', ten: 'battery charging full'},
      {id: 'battery_full', ten: 'battery full'},
      {id: 'battery_std', ten: 'battery std'},
      {id: 'battery_unknown', ten: 'battery unknown'},
      {id: 'beach_access', ten: 'beach access'},
      {id: 'beenhere', ten: 'beenhere'},
      {id: 'block', ten: 'block'},
      {id: 'bluetooth', ten: 'bluetooth'},
      {id: 'bluetooth_audio', ten: 'bluetooth audio'},
      {id: 'bluetooth_connected', ten: 'bluetooth connected'},
      {id: 'bluetooth_disabled', ten: 'bluetooth disabled'},
      {id: 'bluetooth_searching', ten: 'bluetooth searching'},
      {id: 'blur_circular', ten: 'blur circular'},
      {id: 'blur_linear', ten: 'blur linear'},
      {id: 'blur_off', ten: 'blur off'},
      {id: 'blur_on', ten: 'blur on'},
      {id: 'book', ten: 'book'},
      {id: 'bookmark', ten: 'bookmark'},
      {id: 'bookmark_border', ten: 'bookmark border'},
      {id: 'border_all', ten: 'border all'},
      {id: 'border_bottom', ten: 'border bottom'},
      {id: 'border_clear', ten: 'border clear'},
      {id: 'border_color', ten: 'border color'},
      {id: 'border_horizontal', ten: 'border horizontal'},
      {id: 'border_inner', ten: 'border inner'},
      {id: 'border_left', ten: 'border left'},
      {id: 'border_outer', ten: 'border outer'},
      {id: 'border_right', ten: 'border right'},
      {id: 'border_style', ten: 'border style'},
      {id: 'border_top', ten: 'border top'},
      {id: 'border_vertical', ten: 'border vertical'},
      {id: 'branding_watermark', ten: 'branding watermark'},
      {id: 'brightness_1', ten: 'brightness 1'},
      {id: 'brightness_2', ten: 'brightness 2'},
      {id: 'brightness_3', ten: 'brightness 3'},
      {id: 'brightness_4', ten: 'brightness 4'},
      {id: 'brightness_5', ten: 'brightness 5'},
      {id: 'brightness_6', ten: 'brightness 6'},
      {id: 'brightness_7', ten: 'brightness 7'},
      {id: 'brightness_auto', ten: 'brightness auto'},
      {id: 'brightness_high', ten: 'brightness high'},
      {id: 'brightness_low', ten: 'brightness low'},
      {id: 'brightness_medium', ten: 'brightness medium'},
      {id: 'broken_image', ten: 'broken image'},
      {id: 'brush', ten: 'brush'},
      {id: 'bubble_chart', ten: 'bubble chart'},
      {id: 'bug_report', ten: 'bug report'},
      {id: 'build', ten: 'build'},
      {id: 'burst_mode', ten: 'burst mode'},
      {id: 'business', ten: 'business'},
      {id: 'business_center', ten: 'business center'},
      {id: 'cached', ten: 'cached'},
      {id: 'cake', ten: 'cake'},
      {id: 'call', ten: 'call'},
      {id: 'call_end', ten: 'call end'},
      {id: 'call_made', ten: 'call made'},
      {id: 'call_merge', ten: 'call merge'},
      {id: 'call_missed', ten: 'call missed'},
      {id: 'call_missed_outgoing', ten: 'call missed outgoing'},
      {id: 'call_received', ten: 'call received'},
      {id: 'call_split', ten: 'call split'},
      {id: 'call_to_action', ten: 'call to action'},
      {id: 'camera', ten: 'camera'},
      {id: 'camera_alt', ten: 'camera alt'},
      {id: 'camera_enhance', ten: 'camera enhance'},
      {id: 'camera_front', ten: 'camera front'},
      {id: 'camera_rear', ten: 'camera rear'},
      {id: 'camera_roll', ten: 'camera roll'},
      {id: 'cancel', ten: 'cancel'},
      {id: 'card_giftcard', ten: 'card giftcard'},
      {id: 'card_membership', ten: 'card membership'},
      {id: 'card_travel', ten: 'card travel'},
      {id: 'casino', ten: 'casino'},
      {id: 'cast', ten: 'cast'},
      {id: 'cast_connected', ten: 'cast connected'},
      {id: 'center_focus_strong', ten: 'center focus strong'},
      {id: 'center_focus_weak', ten: 'center focus weak'},
      {id: 'change_history', ten: 'change history'},
      {id: 'chat', ten: 'chat'},
      {id: 'chat_bubble', ten: 'chat bubble'},
      {id: 'chat_bubble_outline', ten: 'chat bubble outline'},
      {id: 'check', ten: 'check'},
      {id: 'check_box', ten: 'check box'},
      {id: 'check_box_outline_blank', ten: 'check box outline blank'},
      {id: 'check_circle', ten: 'check circle'},
      {id: 'chevron_left', ten: 'chevron left'},
      {id: 'chevron_right', ten: 'chevron right'},
      {id: 'child_care', ten: 'child care'},
      {id: 'child_friendly', ten: 'child friendly'},
      {id: 'chrome_reader_mode', ten: 'chrome reader mode'},
      {id: 'class', ten: 'class'},
      {id: 'clear', ten: 'clear'},
      {id: 'clear_all', ten: 'clear all'},
      {id: 'close', ten: 'close'},
      {id: 'closed_caption', ten: 'closed caption'},
      {id: 'cloud', ten: 'cloud'},
      {id: 'cloud_circle', ten: 'cloud circle'},
      {id: 'cloud_done', ten: 'cloud done'},
      {id: 'cloud_download', ten: 'cloud download'},
      {id: 'cloud_off', ten: 'cloud off'},
      {id: 'cloud_queue', ten: 'cloud queue'},
      {id: 'cloud_upload', ten: 'cloud upload'},
      {id: 'code', ten: 'code'},
      {id: 'collections', ten: 'collections'},
      {id: 'collections_bookmark', ten: 'collections bookmark'},
      {id: 'color_lens', ten: 'color lens'},
      {id: 'colorize', ten: 'colorize'},
      {id: 'comment', ten: 'comment'},
      {id: 'compare', ten: 'compare'},
      {id: 'compare_arrows', ten: 'compare arrows'},
      {id: 'computer', ten: 'computer'},
      {id: 'confirmation_number', ten: 'confirmation number'},
      {id: 'contact_mail', ten: 'contact mail'},
      {id: 'contact_phone', ten: 'contact phone'},
      {id: 'contacts', ten: 'contacts'},
      {id: 'content_copy', ten: 'content copy'},
      {id: 'content_cut', ten: 'content cut'},
      {id: 'content_paste', ten: 'content paste'},
      {id: 'control_point', ten: 'control point'},
      {id: 'control_point_duplicate', ten: 'control point duplicate'},
      {id: 'copyright', ten: 'copyright'},
      {id: 'create', ten: 'create'},
      {id: 'create_new_folder', ten: 'create new folder'},
      {id: 'credit_card', ten: 'credit card'},
      {id: 'crop', ten: 'crop'},
      {id: 'crop_16_9', ten: 'crop 16 9'},
      {id: 'crop_3_2', ten: 'crop 3 2'},
      {id: 'crop_5_4', ten: 'crop 5 4'},
      {id: 'crop_7_5', ten: 'crop 7 5'},
      {id: 'crop_din', ten: 'crop din'},
      {id: 'crop_free', ten: 'crop free'},
      {id: 'crop_landscape', ten: 'crop landscape'},
      {id: 'crop_original', ten: 'crop original'},
      {id: 'crop_portrait', ten: 'crop portrait'},
      {id: 'crop_rotate', ten: 'crop rotate'},
      {id: 'crop_square', ten: 'crop square'},
      {id: 'dashboard', ten: 'dashboard'},
      {id: 'data_usage', ten: 'data usage'},
      {id: 'date_range', ten: 'date range'},
      {id: 'dehaze', ten: 'dehaze'},
      {id: 'delete', ten: 'delete'},
      {id: 'delete_forever', ten: 'delete forever'},
      {id: 'delete_sweep', ten: 'delete sweep'},
      {id: 'description', ten: 'description'},
      {id: 'desktop_mac', ten: 'desktop mac'},
      {id: 'desktop_windows', ten: 'desktop windows'},
      {id: 'details', ten: 'details'},
      {id: 'developer_board', ten: 'developer board'},
      {id: 'developer_mode', ten: 'developer mode'},
      {id: 'device_hub', ten: 'device hub'},
      {id: 'devices', ten: 'devices'},
      {id: 'devices_other', ten: 'devices other'},
      {id: 'dialer_sip', ten: 'dialer sip'},
      {id: 'dialpad', ten: 'dialpad'},
      {id: 'directions', ten: 'directions'},
      {id: 'directions_bike', ten: 'directions bike'},
      {id: 'directions_boat', ten: 'directions boat'},
      {id: 'directions_bus', ten: 'directions bus'},
      {id: 'directions_car', ten: 'directions car'},
      {id: 'directions_railway', ten: 'directions railway'},
      {id: 'directions_run', ten: 'directions run'},
      {id: 'directions_subway', ten: 'directions subway'},
      {id: 'directions_transit', ten: 'directions transit'},
      {id: 'directions_walk', ten: 'directions walk'},
      {id: 'disc_full', ten: 'disc full'},
      {id: 'dns', ten: 'dns'},
      {id: 'do_not_disturb', ten: 'do not disturb'},
      {id: 'do_not_disturb_alt', ten: 'do not disturb alt'},
      {id: 'do_not_disturb_off', ten: 'do not disturb off'},
      {id: 'do_not_disturb_on', ten: 'do not disturb on'},
      {id: 'dock', ten: 'dock'},
      {id: 'domain', ten: 'domain'},
      {id: 'done', ten: 'done'},
      {id: 'done_all', ten: 'done all'},
      {id: 'donut_large', ten: 'donut large'},
      {id: 'donut_small', ten: 'donut small'},
      {id: 'drafts', ten: 'drafts'},
      {id: 'drag_handle', ten: 'drag handle'},
      {id: 'drive_eta', ten: 'drive eta'},
      {id: 'dvr', ten: 'dvr'},
      {id: 'edit', ten: 'edit'},
      {id: 'edit_location', ten: 'edit location'},
      {id: 'eject', ten: 'eject'},
      {id: 'email', ten: 'email'},
      {id: 'enhanced_encryption', ten: 'enhanced encryption'},
      {id: 'equalizer', ten: 'equalizer'},
      {id: 'error', ten: 'error'},
      {id: 'error_outline', ten: 'error outline'},
      {id: 'euro_symbol', ten: 'euro symbol'},
      {id: 'ev_station', ten: 'ev station'},
      {id: 'event', ten: 'event'},
      {id: 'event_available', ten: 'event available'},
      {id: 'event_busy', ten: 'event busy'},
      {id: 'event_note', ten: 'event note'},
      {id: 'event_seat', ten: 'event seat'},
      {id: 'exit_to_app', ten: 'exit to app'},
      {id: 'expand_less', ten: 'expand less'},
      {id: 'expand_more', ten: 'expand more'},
      {id: 'explicit', ten: 'explicit'},
      {id: 'explore', ten: 'explore'},
      {id: 'exposure', ten: 'exposure'},
      {id: 'exposure_neg_1', ten: 'exposure neg 1'},
      {id: 'exposure_neg_2', ten: 'exposure neg 2'},
      {id: 'exposure_plus_1', ten: 'exposure plus 1'},
      {id: 'exposure_plus_2', ten: 'exposure plus 2'},
      {id: 'exposure_zero', ten: 'exposure zero'},
      {id: 'extension', ten: 'extension'},
      {id: 'face', ten: 'face'},
      {id: 'fast_forward', ten: 'fast forward'},
      {id: 'fast_rewind', ten: 'fast rewind'},
      {id: 'favorite', ten: 'favorite'},
      {id: 'favorite_border', ten: 'favorite border'},
      {id: 'featured_play_list', ten: 'featured play list'},
      {id: 'featured_video', ten: 'featured video'},
      {id: 'feedback', ten: 'feedback'},
      {id: 'fiber_dvr', ten: 'fiber dvr'},
      {id: 'fiber_manual_record', ten: 'fiber manual record'},
      {id: 'fiber_new', ten: 'fiber new'},
      {id: 'fiber_pin', ten: 'fiber pin'},
      {id: 'fiber_smart_record', ten: 'fiber smart record'},
      {id: 'file_download', ten: 'file download'},
      {id: 'file_upload', ten: 'file upload'},
      {id: 'filter', ten: 'filter'},
      {id: 'filter_1', ten: 'filter 1'},
      {id: 'filter_2', ten: 'filter 2'},
      {id: 'filter_3', ten: 'filter 3'},
      {id: 'filter_4', ten: 'filter 4'},
      {id: 'filter_5', ten: 'filter 5'},
      {id: 'filter_6', ten: 'filter 6'},
      {id: 'filter_7', ten: 'filter 7'},
      {id: 'filter_8', ten: 'filter 8'},
      {id: 'filter_9', ten: 'filter 9'},
      {id: 'filter_9_plus', ten: 'filter 9 plus'},
      {id: 'filter_b_and_w', ten: 'filter b and w'},
      {id: 'filter_center_focus', ten: 'filter center focus'},
      {id: 'filter_drama', ten: 'filter drama'},
      {id: 'filter_frames', ten: 'filter frames'},
      {id: 'filter_hdr', ten: 'filter hdr'},
      {id: 'filter_list', ten: 'filter list'},
      {id: 'filter_none', ten: 'filter none'},
      {id: 'filter_tilt_shift', ten: 'filter tilt shift'},
      {id: 'filter_vintage', ten: 'filter vintage'},
      {id: 'find_in_page', ten: 'find in page'},
      {id: 'find_replace', ten: 'find replace'},
      {id: 'fingerprint', ten: 'fingerprint'},
      {id: 'first_page', ten: 'first page'},
      {id: 'fitness_center', ten: 'fitness center'},
      {id: 'flag', ten: 'flag'},
      {id: 'flare', ten: 'flare'},
      {id: 'flash_auto', ten: 'flash auto'},
      {id: 'flash_off', ten: 'flash off'},
      {id: 'flash_on', ten: 'flash on'},
      {id: 'flight', ten: 'flight'},
      {id: 'flight_land', ten: 'flight land'},
      {id: 'flight_takeoff', ten: 'flight takeoff'},
      {id: 'flip', ten: 'flip'},
      {id: 'flip_to_back', ten: 'flip to back'},
      {id: 'flip_to_front', ten: 'flip to front'},
      {id: 'folder', ten: 'folder'},
      {id: 'folder_open', ten: 'folder open'},
      {id: 'folder_shared', ten: 'folder shared'},
      {id: 'folder_special', ten: 'folder special'},
      {id: 'font_download', ten: 'font download'},
      {id: 'format_align_center', ten: 'format align center'},
      {id: 'format_align_justify', ten: 'format align justify'},
      {id: 'format_align_left', ten: 'format align left'},
      {id: 'format_align_right', ten: 'format align right'},
      {id: 'format_bold', ten: 'format bold'},
      {id: 'format_clear', ten: 'format clear'},
      {id: 'format_color_fill', ten: 'format color fill'},
      {id: 'format_color_reset', ten: 'format color reset'},
      {id: 'format_color_text', ten: 'format color text'},
      {id: 'format_indent_decrease', ten: 'format indent decrease'},
      {id: 'format_indent_increase', ten: 'format indent increase'},
      {id: 'format_italic', ten: 'format italic'},
      {id: 'format_line_spacing', ten: 'format line spacing'},
      {id: 'format_list_bulleted', ten: 'format list bulleted'},
      {id: 'format_list_numbered', ten: 'format list numbered'},
      {id: 'format_paint', ten: 'format paint'},
      {id: 'format_quote', ten: 'format quote'},
      {id: 'format_shapes', ten: 'format shapes'},
      {id: 'format_size', ten: 'format size'},
      {id: 'format_strikethrough', ten: 'format strikethrough'},
      {id: 'format_textdirection_l_to_r', ten: 'format textdirection l to r'},
      {id: 'format_textdirection_r_to_l', ten: 'format textdirection r to l'},
      {id: 'format_underlined', ten: 'format underlined'},
      {id: 'forum', ten: 'forum'},
      {id: 'forward', ten: 'forward'},
      {id: 'forward_10', ten: 'forward 10'},
      {id: 'forward_30', ten: 'forward 30'},
      {id: 'forward_5', ten: 'forward 5'},
      {id: 'free_breakfast', ten: 'free breakfast'},
      {id: 'fullscreen', ten: 'fullscreen'},
      {id: 'fullscreen_exit', ten: 'fullscreen exit'},
      {id: 'functions', ten: 'functions'},
      {id: 'g_translate', ten: 'g translate'},
      {id: 'gamepad', ten: 'gamepad'},
      {id: 'games', ten: 'games'},
      {id: 'gavel', ten: 'gavel'},
      {id: 'gesture', ten: 'gesture'},
      {id: 'get_app', ten: 'get app'},
      {id: 'gif', ten: 'gif'},
      {id: 'golf_course', ten: 'golf course'},
      {id: 'gps_fixed', ten: 'gps fixed'},
      {id: 'gps_not_fixed', ten: 'gps not fixed'},
      {id: 'gps_off', ten: 'gps off'},
      {id: 'grade', ten: 'grade'},
      {id: 'gradient', ten: 'gradient'},
      {id: 'grain', ten: 'grain'},
      {id: 'graphic_eq', ten: 'graphic eq'},
      {id: 'grid_off', ten: 'grid off'},
      {id: 'grid_on', ten: 'grid on'},
      {id: 'group', ten: 'group'},
      {id: 'group_add', ten: 'group add'},
      {id: 'group_work', ten: 'group work'},
      {id: 'hd', ten: 'hd'},
      {id: 'hdr_off', ten: 'hdr off'},
      {id: 'hdr_on', ten: 'hdr on'},
      {id: 'hdr_strong', ten: 'hdr strong'},
      {id: 'hdr_weak', ten: 'hdr weak'},
      {id: 'headset', ten: 'headset'},
      {id: 'headset_mic', ten: 'headset mic'},
      {id: 'healing', ten: 'healing'},
      {id: 'hearing', ten: 'hearing'},
      {id: 'help', ten: 'help'},
      {id: 'help_outline', ten: 'help outline'},
      {id: 'high_quality', ten: 'high quality'},
      {id: 'highlight', ten: 'highlight'},
      {id: 'highlight_off', ten: 'highlight off'},
      {id: 'history', ten: 'history'},
      {id: 'home', ten: 'home'},
      {id: 'hot_tub', ten: 'hot tub'},
      {id: 'hotel', ten: 'hotel'},
      {id: 'hourglass_empty', ten: 'hourglass empty'},
      {id: 'hourglass_full', ten: 'hourglass full'},
      {id: 'http', ten: 'http'},
      {id: 'https', ten: 'https'},
      {id: 'image', ten: 'image'},
      {id: 'image_aspect_ratio', ten: 'image aspect ratio'},
      {id: 'import_contacts', ten: 'import contacts'},
      {id: 'import_export', ten: 'import export'},
      {id: 'important_devices', ten: 'important devices'},
      {id: 'inbox', ten: 'inbox'},
      {id: 'indeterminate_check_box', ten: 'indeterminate check box'},
      {id: 'info', ten: 'info'},
      {id: 'info_outline', ten: 'info outline'},
      {id: 'input', ten: 'input'},
      {id: 'insert_chart', ten: 'insert chart'},
      {id: 'insert_comment', ten: 'insert comment'},
      {id: 'insert_drive_file', ten: 'insert drive file'},
      {id: 'insert_emoticon', ten: 'insert emoticon'},
      {id: 'insert_invitation', ten: 'insert invitation'},
      {id: 'insert_link', ten: 'insert link'},
      {id: 'insert_photo', ten: 'insert photo'},
      {id: 'invert_colors', ten: 'invert colors'},
      {id: 'invert_colors_off', ten: 'invert colors off'},
      {id: 'iso', ten: 'iso'},
      {id: 'keyboard', ten: 'keyboard'},
      {id: 'keyboard_arrow_down', ten: 'keyboard arrow down'},
      {id: 'keyboard_arrow_left', ten: 'keyboard arrow left'},
      {id: 'keyboard_arrow_right', ten: 'keyboard arrow right'},
      {id: 'keyboard_arrow_up', ten: 'keyboard arrow up'},
      {id: 'keyboard_backspace', ten: 'keyboard backspace'},
      {id: 'keyboard_capslock', ten: 'keyboard capslock'},
      {id: 'keyboard_hide', ten: 'keyboard hide'},
      {id: 'keyboard_return', ten: 'keyboard return'},
      {id: 'keyboard_tab', ten: 'keyboard tab'},
      {id: 'keyboard_voice', ten: 'keyboard voice'},
      {id: 'kitchen', ten: 'kitchen'},
      {id: 'label', ten: 'label'},
      {id: 'label_outline', ten: 'label outline'},
      {id: 'landscape', ten: 'landscape'},
      {id: 'language', ten: 'language'},
      {id: 'laptop', ten: 'laptop'},
      {id: 'laptop_chromebook', ten: 'laptop chromebook'},
      {id: 'laptop_mac', ten: 'laptop mac'},
      {id: 'laptop_windows', ten: 'laptop windows'},
      {id: 'last_page', ten: 'last page'},
      {id: 'launch', ten: 'launch'},
      {id: 'layers', ten: 'layers'},
      {id: 'layers_clear', ten: 'layers clear'},
      {id: 'leak_add', ten: 'leak add'},
      {id: 'leak_remove', ten: 'leak remove'},
      {id: 'lens', ten: 'lens'},
      {id: 'library_add', ten: 'library add'},
      {id: 'library_books', ten: 'library books'},
      {id: 'library_music', ten: 'library music'},
      {id: 'lightbulb_outline', ten: 'lightbulb outline'},
      {id: 'line_style', ten: 'line style'},
      {id: 'line_weight', ten: 'line weight'},
      {id: 'linear_scale', ten: 'linear scale'},
      {id: 'link', ten: 'link'},
      {id: 'linked_camera', ten: 'linked camera'},
      {id: 'list', ten: 'list'},
      {id: 'live_help', ten: 'live help'},
      {id: 'live_tv', ten: 'live tv'},
      {id: 'local_activity', ten: 'local activity'},
      {id: 'local_airport', ten: 'local airport'},
      {id: 'local_atm', ten: 'local atm'},
      {id: 'local_bar', ten: 'local bar'},
      {id: 'local_cafe', ten: 'local cafe'},
      {id: 'local_car_wash', ten: 'local car wash'},
      {id: 'local_convenience_store', ten: 'local convenience store'},
      {id: 'local_dining', ten: 'local dining'},
      {id: 'local_drink', ten: 'local drink'},
      {id: 'local_florist', ten: 'local florist'},
      {id: 'local_gas_station', ten: 'local gas station'},
      {id: 'local_grocery_store', ten: 'local grocery store'},
      {id: 'local_hospital', ten: 'local hospital'},
      {id: 'local_hotel', ten: 'local hotel'},
      {id: 'local_laundry_service', ten: 'local laundry service'},
      {id: 'local_library', ten: 'local library'},
      {id: 'local_mall', ten: 'local mall'},
      {id: 'local_movies', ten: 'local movies'},
      {id: 'local_offer', ten: 'local offer'},
      {id: 'local_parking', ten: 'local parking'},
      {id: 'local_pharmacy', ten: 'local pharmacy'},
      {id: 'local_phone', ten: 'local phone'},
      {id: 'local_pizza', ten: 'local pizza'},
      {id: 'local_play', ten: 'local play'},
      {id: 'local_post_office', ten: 'local post office'},
      {id: 'local_printshop', ten: 'local printshop'},
      {id: 'local_see', ten: 'local see'},
      {id: 'local_shipping', ten: 'local shipping'},
      {id: 'local_taxi', ten: 'local taxi'},
      {id: 'location_city', ten: 'location city'},
      {id: 'location_disabled', ten: 'location disabled'},
      {id: 'location_off', ten: 'location off'},
      {id: 'location_on', ten: 'location on'},
      {id: 'location_searching', ten: 'location searching'},
      {id: 'lock', ten: 'lock'},
      {id: 'lock_open', ten: 'lock open'},
      {id: 'lock_outline', ten: 'lock outline'},
      {id: 'looks', ten: 'looks'},
      {id: 'looks_3', ten: 'looks 3'},
      {id: 'looks_4', ten: 'looks 4'},
      {id: 'looks_5', ten: 'looks 5'},
      {id: 'looks_6', ten: 'looks 6'},
      {id: 'looks_one', ten: 'looks one'},
      {id: 'looks_two', ten: 'looks two'},
      {id: 'loop', ten: 'loop'},
      {id: 'loupe', ten: 'loupe'},
      {id: 'low_priority', ten: 'low priority'},
      {id: 'loyalty', ten: 'loyalty'},
      {id: 'mail', ten: 'mail'},
      {id: 'mail_outline', ten: 'mail outline'},
      {id: 'map', ten: 'map'},
      {id: 'markunread', ten: 'markunread'},
      {id: 'markunread_mailbox', ten: 'markunread mailbox'},
      {id: 'memory', ten: 'memory'},
      {id: 'menu', ten: 'menu'},
      {id: 'merge_type', ten: 'merge type'},
      {id: 'message', ten: 'message'},
      {id: 'mic', ten: 'mic'},
      {id: 'mic_none', ten: 'mic none'},
      {id: 'mic_off', ten: 'mic off'},
      {id: 'mms', ten: 'mms'},
      {id: 'mode_comment', ten: 'mode comment'},
      {id: 'mode_edit', ten: 'mode edit'},
      {id: 'monetization_on', ten: 'monetization on'},
      {id: 'money_off', ten: 'money off'},
      {id: 'monochrome_photos', ten: 'monochrome photos'},
      {id: 'mood', ten: 'mood'},
      {id: 'mood_bad', ten: 'mood bad'},
      {id: 'more', ten: 'more'},
      {id: 'more_horiz', ten: 'more horiz'},
      {id: 'more_vert', ten: 'more vert'},
      {id: 'motorcycle', ten: 'motorcycle'},
      {id: 'mouse', ten: 'mouse'},
      {id: 'move_to_inbox', ten: 'move to inbox'},
      {id: 'movie', ten: 'movie'},
      {id: 'movie_creation', ten: 'movie creation'},
      {id: 'movie_filter', ten: 'movie filter'},
      {id: 'multiline_chart', ten: 'multiline chart'},
      {id: 'music_note', ten: 'music note'},
      {id: 'music_video', ten: 'music video'},
      {id: 'my_location', ten: 'my location'},
      {id: 'nature', ten: 'nature'},
      {id: 'nature_people', ten: 'nature people'},
      {id: 'navigate_before', ten: 'navigate before'},
      {id: 'navigate_next', ten: 'navigate next'},
      {id: 'navigation', ten: 'navigation'},
      {id: 'near_me', ten: 'near me'},
      {id: 'network_cell', ten: 'network cell'},
      {id: 'network_check', ten: 'network check'},
      {id: 'network_locked', ten: 'network locked'},
      {id: 'network_wifi', ten: 'network wifi'},
      {id: 'new_releases', ten: 'new releases'},
      {id: 'next_week', ten: 'next week'},
      {id: 'nfc', ten: 'nfc'},
      {id: 'no_encryption', ten: 'no encryption'},
      {id: 'no_sim', ten: 'no sim'},
      {id: 'not_interested', ten: 'not interested'},
      {id: 'note', ten: 'note'},
      {id: 'note_add', ten: 'note add'},
      {id: 'notifications', ten: 'notifications'},
      {id: 'notifications_active', ten: 'notifications active'},
      {id: 'notifications_none', ten: 'notifications none'},
      {id: 'notifications_off', ten: 'notifications off'},
      {id: 'notifications_paused', ten: 'notifications paused'},
      {id: 'offline_pin', ten: 'offline pin'},
      {id: 'ondemand_video', ten: 'ondemand video'},
      {id: 'opacity', ten: 'opacity'},
      {id: 'open_in_browser', ten: 'open in browser'},
      {id: 'open_in_new', ten: 'open in new'},
      {id: 'open_with', ten: 'open with'},
      {id: 'pages', ten: 'pages'},
      {id: 'pageview', ten: 'pageview'},
      {id: 'palette', ten: 'palette'},
      {id: 'pan_tool', ten: 'pan tool'},
      {id: 'panorama', ten: 'panorama'},
      {id: 'panorama_fish_eye', ten: 'panorama fish eye'},
      {id: 'panorama_horizontal', ten: 'panorama horizontal'},
      {id: 'panorama_vertical', ten: 'panorama vertical'},
      {id: 'panorama_wide_angle', ten: 'panorama wide angle'},
      {id: 'party_mode', ten: 'party mode'},
      {id: 'pause', ten: 'pause'},
      {id: 'pause_circle_filled', ten: 'pause circle filled'},
      {id: 'pause_circle_outline', ten: 'pause circle outline'},
      {id: 'payment', ten: 'payment'},
      {id: 'people', ten: 'people'},
      {id: 'people_outline', ten: 'people outline'},
      {id: 'perm_camera_mic', ten: 'perm camera mic'},
      {id: 'perm_contact_calendar', ten: 'perm contact calendar'},
      {id: 'perm_data_setting', ten: 'perm data setting'},
      {id: 'perm_device_information', ten: 'perm device information'},
      {id: 'perm_identity', ten: 'perm identity'},
      {id: 'perm_media', ten: 'perm media'},
      {id: 'perm_phone_msg', ten: 'perm phone msg'},
      {id: 'perm_scan_wifi', ten: 'perm scan wifi'},
      {id: 'person', ten: 'person'},
      {id: 'person_add', ten: 'person add'},
      {id: 'person_outline', ten: 'person outline'},
      {id: 'person_pin', ten: 'person pin'},
      {id: 'person_pin_circle', ten: 'person pin circle'},
      {id: 'personal_video', ten: 'personal video'},
      {id: 'pets', ten: 'pets'},
      {id: 'phone', ten: 'phone'},
      {id: 'phone_android', ten: 'phone android'},
      {id: 'phone_bluetooth_speaker', ten: 'phone bluetooth speaker'},
      {id: 'phone_forwarded', ten: 'phone forwarded'},
      {id: 'phone_in_talk', ten: 'phone in talk'},
      {id: 'phone_iphone', ten: 'phone iphone'},
      {id: 'phone_locked', ten: 'phone locked'},
      {id: 'phone_missed', ten: 'phone missed'},
      {id: 'phone_paused', ten: 'phone paused'},
      {id: 'phonelink', ten: 'phonelink'},
      {id: 'phonelink_erase', ten: 'phonelink erase'},
      {id: 'phonelink_lock', ten: 'phonelink lock'},
      {id: 'phonelink_off', ten: 'phonelink off'},
      {id: 'phonelink_ring', ten: 'phonelink ring'},
      {id: 'phonelink_setup', ten: 'phonelink setup'},
      {id: 'photo', ten: 'photo'},
      {id: 'photo_album', ten: 'photo album'},
      {id: 'photo_camera', ten: 'photo camera'},
      {id: 'photo_filter', ten: 'photo filter'},
      {id: 'photo_library', ten: 'photo library'},
      {id: 'photo_size_select_actual', ten: 'photo size select actual'},
      {id: 'photo_size_select_large', ten: 'photo size select large'},
      {id: 'photo_size_select_small', ten: 'photo size select small'},
      {id: 'picture_as_pdf', ten: 'picture as pdf'},
      {id: 'picture_in_picture', ten: 'picture in picture'},
      {id: 'picture_in_picture_alt', ten: 'picture in picture alt'},
      {id: 'pie_chart', ten: 'pie chart'},
      {id: 'pie_chart_outlined', ten: 'pie chart outlined'},
      {id: 'pin_drop', ten: 'pin drop'},
      {id: 'place', ten: 'place'},
      {id: 'play_arrow', ten: 'play arrow'},
      {id: 'play_circle_filled', ten: 'play circle filled'},
      {id: 'play_circle_outline', ten: 'play circle outline'},
      {id: 'play_for_work', ten: 'play for work'},
      {id: 'playlist_add', ten: 'playlist add'},
      {id: 'playlist_add_check', ten: 'playlist add check'},
      {id: 'playlist_play', ten: 'playlist play'},
      {id: 'plus_one', ten: 'plus one'},
      {id: 'poll', ten: 'poll'},
      {id: 'polymer', ten: 'polymer'},
      {id: 'pool', ten: 'pool'},
      {id: 'portable_wifi_off', ten: 'portable wifi off'},
      {id: 'portrait', ten: 'portrait'},
      {id: 'power', ten: 'power'},
      {id: 'power_input', ten: 'power input'},
      {id: 'power_settings_new', ten: 'power settings new'},
      {id: 'pregnant_woman', ten: 'pregnant woman'},
      {id: 'present_to_all', ten: 'present to all'},
      {id: 'print', ten: 'print'},
      {id: 'priority_high', ten: 'priority high'},
      {id: 'public', ten: 'public'},
      {id: 'publish', ten: 'publish'},
      {id: 'query_builder', ten: 'query builder'},
      {id: 'question_answer', ten: 'question answer'},
      {id: 'queue', ten: 'queue'},
      {id: 'queue_music', ten: 'queue music'},
      {id: 'queue_play_next', ten: 'queue play next'},
      {id: 'radio', ten: 'radio'},
      {id: 'radio_button_checked', ten: 'radio button checked'},
      {id: 'radio_button_unchecked', ten: 'radio button unchecked'},
      {id: 'rate_review', ten: 'rate review'},
      {id: 'receipt', ten: 'receipt'},
      {id: 'recent_actors', ten: 'recent actors'},
      {id: 'record_voice_over', ten: 'record voice over'},
      {id: 'redeem', ten: 'redeem'},
      {id: 'redo', ten: 'redo'},
      {id: 'refresh', ten: 'refresh'},
      {id: 'remove', ten: 'remove'},
      {id: 'remove_circle', ten: 'remove circle'},
      {id: 'remove_circle_outline', ten: 'remove circle outline'},
      {id: 'remove_from_queue', ten: 'remove from queue'},
      {id: 'remove_red_eye', ten: 'remove red eye'},
      {id: 'remove_shopping_cart', ten: 'remove shopping cart'},
      {id: 'reorder', ten: 'reorder'},
      {id: 'repeat', ten: 'repeat'},
      {id: 'repeat_one', ten: 'repeat one'},
      {id: 'replay', ten: 'replay'},
      {id: 'replay_10', ten: 'replay 10'},
      {id: 'replay_30', ten: 'replay 30'},
      {id: 'replay_5', ten: 'replay 5'},
      {id: 'reply', ten: 'reply'},
      {id: 'reply_all', ten: 'reply all'},
      {id: 'report', ten: 'report'},
      {id: 'report_problem', ten: 'report problem'},
      {id: 'restaurant', ten: 'restaurant'},
      {id: 'restaurant_menu', ten: 'restaurant menu'},
      {id: 'restore', ten: 'restore'},
      {id: 'restore_page', ten: 'restore page'},
      {id: 'ring_volume', ten: 'ring volume'},
      {id: 'room', ten: 'room'},
      {id: 'room_service', ten: 'room service'},
      {id: 'rotate_90_degrees_ccw', ten: 'rotate 90 degrees ccw'},
      {id: 'rotate_left', ten: 'rotate left'},
      {id: 'rotate_right', ten: 'rotate right'},
      {id: 'rounded_corner', ten: 'rounded corner'},
      {id: 'router', ten: 'router'},
      {id: 'rowing', ten: 'rowing'},
      {id: 'rss_feed', ten: 'rss feed'},
      {id: 'rv_hookup', ten: 'rv hookup'},
      {id: 'satellite', ten: 'satellite'},
      {id: 'save', ten: 'save'},
      {id: 'scanner', ten: 'scanner'},
      {id: 'schedule', ten: 'schedule'},
      {id: 'school', ten: 'school'},
      {id: 'screen_lock_landscape', ten: 'screen lock landscape'},
      {id: 'screen_lock_portrait', ten: 'screen lock portrait'},
      {id: 'screen_lock_rotation', ten: 'screen lock rotation'},
      {id: 'screen_rotation', ten: 'screen rotation'},
      {id: 'screen_share', ten: 'screen share'},
      {id: 'sd_card', ten: 'sd card'},
      {id: 'sd_storage', ten: 'sd storage'},
      {id: 'search', ten: 'search'},
      {id: 'security', ten: 'security'},
      {id: 'select_all', ten: 'select all'},
      {id: 'send', ten: 'send'},
      {id: 'sentiment_dissatisfied', ten: 'sentiment dissatisfied'},
      {id: 'sentiment_neutral', ten: 'sentiment neutral'},
      {id: 'sentiment_satisfied', ten: 'sentiment satisfied'},
      {id: 'sentiment_very_dissatisfied', ten: 'sentiment very dissatisfied'},
      {id: 'sentiment_very_satisfied', ten: 'sentiment very satisfied'},
      {id: 'settings', ten: 'settings'},
      {id: 'settings_applications', ten: 'settings applications'},
      {id: 'settings_backup_restore', ten: 'settings backup restore'},
      {id: 'settings_bluetooth', ten: 'settings bluetooth'},
      {id: 'settings_brightness', ten: 'settings brightness'},
      {id: 'settings_cell', ten: 'settings cell'},
      {id: 'settings_ethernet', ten: 'settings ethernet'},
      {id: 'settings_input_antenna', ten: 'settings input antenna'},
      {id: 'settings_input_component', ten: 'settings input component'},
      {id: 'settings_input_composite', ten: 'settings input composite'},
      {id: 'settings_input_hdmi', ten: 'settings input hdmi'},
      {id: 'settings_input_svideo', ten: 'settings input svideo'},
      {id: 'settings_overscan', ten: 'settings overscan'},
      {id: 'settings_phone', ten: 'settings phone'},
      {id: 'settings_power', ten: 'settings power'},
      {id: 'settings_remote', ten: 'settings remote'},
      {id: 'settings_system_daydream', ten: 'settings system daydream'},
      {id: 'settings_voice', ten: 'settings voice'},
      {id: 'share', ten: 'share'},
      {id: 'shop', ten: 'shop'},
      {id: 'shop_two', ten: 'shop two'},
      {id: 'shopping_basket', ten: 'shopping basket'},
      {id: 'shopping_cart', ten: 'shopping cart'},
      {id: 'short_text', ten: 'short text'},
      {id: 'show_chart', ten: 'show chart'},
      {id: 'shuffle', ten: 'shuffle'},
      {id: 'signal_cellular_4_bar', ten: 'signal cellular 4 bar'},
      {id: 'signal_cellular_connected_no_internet_4_bar', ten: 'signal cellular connected no internet 4 bar'},
      {id: 'signal_cellular_no_sim', ten: 'signal cellular no sim'},
      {id: 'signal_cellular_null', ten: 'signal cellular null'},
      {id: 'signal_cellular_off', ten: 'signal cellular off'},
      {id: 'signal_wifi_4_bar', ten: 'signal wifi 4 bar'},
      {id: 'signal_wifi_4_bar_lock', ten: 'signal wifi 4 bar lock'},
      {id: 'signal_wifi_off', ten: 'signal wifi off'},
      {id: 'sim_card', ten: 'sim card'},
      {id: 'sim_card_alert', ten: 'sim card alert'},
      {id: 'skip_next', ten: 'skip next'},
      {id: 'skip_previous', ten: 'skip previous'},
      {id: 'slideshow', ten: 'slideshow'},
      {id: 'slow_motion_video', ten: 'slow motion video'},
      {id: 'smartphone', ten: 'smartphone'},
      {id: 'smoke_free', ten: 'smoke free'},
      {id: 'smoking_rooms', ten: 'smoking rooms'},
      {id: 'sms', ten: 'sms'},
      {id: 'sms_failed', ten: 'sms failed'},
      {id: 'snooze', ten: 'snooze'},
      {id: 'sort', ten: 'sort'},
      {id: 'sort_by_alpha', ten: 'sort by alpha'},
      {id: 'spa', ten: 'spa'},
      {id: 'space_bar', ten: 'space bar'},
      {id: 'speaker', ten: 'speaker'},
      {id: 'speaker_group', ten: 'speaker group'},
      {id: 'speaker_notes', ten: 'speaker notes'},
      {id: 'speaker_notes_off', ten: 'speaker notes off'},
      {id: 'speaker_phone', ten: 'speaker phone'},
      {id: 'spellcheck', ten: 'spellcheck'},
      {id: 'star', ten: 'star'},
      {id: 'star_border', ten: 'star border'},
      {id: 'star_half', ten: 'star half'},
      {id: 'stars', ten: 'stars'},
      {id: 'stay_current_landscape', ten: 'stay current landscape'},
      {id: 'stay_current_portrait', ten: 'stay current portrait'},
      {id: 'stay_primary_landscape', ten: 'stay primary landscape'},
      {id: 'stay_primary_portrait', ten: 'stay primary portrait'},
      {id: 'stop', ten: 'stop'},
      {id: 'stop_screen_share', ten: 'stop screen share'},
      {id: 'storage', ten: 'storage'},
      {id: 'store', ten: 'store'},
      {id: 'store_mall_directory', ten: 'store mall directory'},
      {id: 'straighten', ten: 'straighten'},
      {id: 'streetview', ten: 'streetview'},
      {id: 'strikethrough_s', ten: 'strikethrough s'},
      {id: 'style', ten: 'style'},
      {id: 'subdirectory_arrow_left', ten: 'subdirectory arrow left'},
      {id: 'subdirectory_arrow_right', ten: 'subdirectory arrow right'},
      {id: 'subject', ten: 'subject'},
      {id: 'subscriptions', ten: 'subscriptions'},
      {id: 'subtitles', ten: 'subtitles'},
      {id: 'subway', ten: 'subway'},
      {id: 'supervisor_account', ten: 'supervisor account'},
      {id: 'surround_sound', ten: 'surround sound'},
      {id: 'swap_calls', ten: 'swap calls'},
      {id: 'swap_horiz', ten: 'swap horiz'},
      {id: 'swap_vert', ten: 'swap vert'},
      {id: 'swap_vertical_circle', ten: 'swap vertical circle'},
      {id: 'switch_camera', ten: 'switch camera'},
      {id: 'switch_video', ten: 'switch video'},
      {id: 'sync', ten: 'sync'},
      {id: 'sync_disabled', ten: 'sync disabled'},
      {id: 'sync_problem', ten: 'sync problem'},
      {id: 'system_update', ten: 'system update'},
      {id: 'system_update_alt', ten: 'system update alt'},
      {id: 'tab', ten: 'tab'},
      {id: 'tab_unselected', ten: 'tab unselected'},
      {id: 'tablet', ten: 'tablet'},
      {id: 'tablet_android', ten: 'tablet android'},
      {id: 'tablet_mac', ten: 'tablet mac'},
      {id: 'tag_faces', ten: 'tag faces'},
      {id: 'tap_and_play', ten: 'tap and play'},
      {id: 'terrain', ten: 'terrain'},
      {id: 'text_fields', ten: 'text fields'},
      {id: 'text_format', ten: 'text format'},
      {id: 'textsms', ten: 'textsms'},
      {id: 'texture', ten: 'texture'},
      {id: 'theaters', ten: 'theaters'},
      {id: 'thumb_down', ten: 'thumb down'},
      {id: 'thumb_up', ten: 'thumb up'},
      {id: 'thumbs_up_down', ten: 'thumbs up down'},
      {id: 'time_to_leave', ten: 'time to leave'},
      {id: 'timelapse', ten: 'timelapse'},
      {id: 'timeline', ten: 'timeline'},
      {id: 'timer', ten: 'timer'},
      {id: 'timer_10', ten: 'timer 10'},
      {id: 'timer_3', ten: 'timer 3'},
      {id: 'timer_off', ten: 'timer off'},
      {id: 'title', ten: 'title'},
      {id: 'toc', ten: 'toc'},
      {id: 'today', ten: 'today'},
      {id: 'toll', ten: 'toll'},
      {id: 'tonality', ten: 'tonality'},
      {id: 'touch_app', ten: 'touch app'},
      {id: 'toys', ten: 'toys'},
      {id: 'track_changes', ten: 'track changes'},
      {id: 'traffic', ten: 'traffic'},
      {id: 'train', ten: 'train'},
      {id: 'tram', ten: 'tram'},
      {id: 'transfer_within_a_station', ten: 'transfer within a station'},
      {id: 'transform', ten: 'transform'},
      {id: 'translate', ten: 'translate'},
      {id: 'trending_down', ten: 'trending down'},
      {id: 'trending_flat', ten: 'trending flat'},
      {id: 'trending_up', ten: 'trending up'},
      {id: 'tune', ten: 'tune'},
      {id: 'turned_in', ten: 'turned in'},
      {id: 'turned_in_not', ten: 'turned in not'},
      {id: 'tv', ten: 'tv'},
      {id: 'unarchive', ten: 'unarchive'},
      {id: 'undo', ten: 'undo'},
      {id: 'unfold_less', ten: 'unfold less'},
      {id: 'unfold_more', ten: 'unfold more'},
      {id: 'update', ten: 'update'},
      {id: 'usb', ten: 'usb'},
      {id: 'verified_user', ten: 'verified user'},
      {id: 'vertical_align_bottom', ten: 'vertical align bottom'},
      {id: 'vertical_align_center', ten: 'vertical align center'},
      {id: 'vertical_align_top', ten: 'vertical align top'},
      {id: 'vibration', ten: 'vibration'},
      {id: 'video_call', ten: 'video call'},
      {id: 'video_label', ten: 'video label'},
      {id: 'video_library', ten: 'video library'},
      {id: 'videocam', ten: 'videocam'},
      {id: 'videocam_off', ten: 'videocam off'},
      {id: 'videogame_asset', ten: 'videogame asset'},
      {id: 'view_agenda', ten: 'view agenda'},
      {id: 'view_array', ten: 'view array'},
      {id: 'view_carousel', ten: 'view carousel'},
      {id: 'view_column', ten: 'view column'},
      {id: 'view_comfy', ten: 'view comfy'},
      {id: 'view_compact', ten: 'view compact'},
      {id: 'view_day', ten: 'view day'},
      {id: 'view_headline', ten: 'view headline'},
      {id: 'view_list', ten: 'view list'},
      {id: 'view_module', ten: 'view module'},
      {id: 'view_quilt', ten: 'view quilt'},
      {id: 'view_stream', ten: 'view stream'},
      {id: 'view_week', ten: 'view week'},
      {id: 'vignette', ten: 'vignette'},
      {id: 'visibility', ten: 'visibility'},
      {id: 'visibility_off', ten: 'visibility off'},
      {id: 'voice_chat', ten: 'voice chat'},
      {id: 'voicemail', ten: 'voicemail'},
      {id: 'volume_down', ten: 'volume down'},
      {id: 'volume_mute', ten: 'volume mute'},
      {id: 'volume_off', ten: 'volume off'},
      {id: 'volume_up', ten: 'volume up'},
      {id: 'vpn_key', ten: 'vpn key'},
      {id: 'vpn_lock', ten: 'vpn lock'},
      {id: 'wallpaper', ten: 'wallpaper'},
      {id: 'warning', ten: 'warning'},
      {id: 'watch', ten: 'watch'},
      {id: 'watch_later', ten: 'watch later'},
      {id: 'wb_auto', ten: 'wb auto'},
      {id: 'wb_cloudy', ten: 'wb cloudy'},
      {id: 'wb_incandescent', ten: 'wb incandescent'},
      {id: 'wb_iridescent', ten: 'wb iridescent'},
      {id: 'wb_sunny', ten: 'wb sunny'},
      {id: 'wc', ten: 'wc'},
      {id: 'web', ten: 'web'},
      {id: 'web_asset', ten: 'web asset'},
      {id: 'weekend', ten: 'weekend'},
      {id: 'whatshot', ten: 'whatshot'},
      {id: 'widgets', ten: 'widgets'},
      {id: 'wifi', ten: 'wifi'},
      {id: 'wifi_lock', ten: 'wifi lock'},
      {id: 'wifi_tethering', ten: 'wifi tethering'},
      {id: 'work', ten: 'work'},
      {id: 'wrap_text', ten: 'wrap text'},
      {id: 'youtube_searched_for', ten: 'youtube searched for'},
      {id: 'zoom_in', ten: 'zoom in'},
      {id: 'zoom_out', ten: 'zoom out'},
      {id: 'zoom_out_map', ten: 'zoom out map'}

    ];
  }
}
